var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.99967C14.6667 4.31967 11.68 1.33301 8.00001 1.33301C4.32001 1.33301 1.33334 4.31967 1.33334 7.99967C1.33334 11.2263 3.62668 13.913 6.66668 14.533V9.99967H5.33334V7.99967H6.66668V6.33301C6.66668 5.04634 7.71334 3.99967 9.00001 3.99967H10.6667V5.99967H9.33334C8.96668 5.99967 8.66668 6.29967 8.66668 6.66634V7.99967H10.6667V9.99967H8.66668V14.633C12.0333 14.2997 14.6667 11.4597 14.6667 7.99967Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f61bb14d.svg";
export { ForwardRef as ReactComponent };